import { render, staticRenderFns } from "./SegmentedTabs.vue?vue&type=template&id=85bd9a60&scoped=true"
import script from "./SegmentedTabs.vue?vue&type=script&lang=js"
export * from "./SegmentedTabs.vue?vue&type=script&lang=js"
import style0 from "./SegmentedTabs.vue?vue&type=style&index=0&id=85bd9a60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85bd9a60",
  null
  
)

export default component.exports